import { extended, http } from '@jota-one/http-client'

let $clients = {}

const responseProcessors = [
  (r, axiosOptions) => {
    if (['post', 'put', 'delete'].includes(axiosOptions.method)) {
      return r
    }
    if (r.data) {
      return r.data
    }

    // special test to handle old MS indexes, but to avoid to systematically shortcut
    // any response with an 'index' key. It's a hack that should work for now, but could
    // need some adjustments...
    // Special route:
    // - File MS: create-session (should not return its index key)
    const keys = Object.keys(r)
    if (
      keys.includes('index') &&
      keys.includes('infoMessages') &&
      keys.length <= 3
    ) {
      return r.index
    }

    return r
  },
]

const factory = {
  create({ axiosConfig, name = 'default', overwrite = false }) {
    if (overwrite || $clients[name] === undefined) {
      $clients[name] = http({
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        ...axiosConfig,
      })
    }

    return $clients[name]
  },

  createHateoas({
    axiosConfig,
    rootEndpoint,
    name = 'default',
    overwrite = false,
  }) {
    if (overwrite || $clients[name] === undefined) {
      $clients[name] = extended({
        axiosConfig,
        rootEndpoint,
        enableLogging: false,
        disableCache: false,
        responseProcessors,
      })
    }

    return $clients[name]
  },
}

export const client = (name = 'default') => {
  return $clients[name]
}

export default factory
